
import { useEmail } from '@/context/EmailContext';

export function useBadgeCount(title: string): number | null {
  const { statistics } = useEmail();

  switch (title) {
    case 'Dashboard':
      return null;
    case 'Chat':
      return null;
    case 'Email':
      // Show unread count for the main Email item only if > 0
      return statistics?.unread > 0 ? statistics.unread : null;
    case 'Inbox':
      // Show unread count only if > 0
      return statistics?.unread > 0 ? statistics.unread : null;
    case 'Sent':
      return null;
    case 'Drafts':
      return null;
    case 'Trash':
      return null;
    default:
      return null;
  }
}
